import React from "react";
import '../../App.css';
import { useEffect } from 'react';
import Footer from "../Footer";
import ContactForm from "../ContactForm";

export default function Contact() {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <>
            <ContactForm />
            <Footer />
        </>
    )
}